export default "__VITE_ASSET__DP6uDkfh__"